// (c) chaehongee. Confidential and proprietary.

import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './LowCreditBanner.module.css'

interface LowCreditBannerProps {
    onRecharge: () => void
}

export function LowCreditBanner({
    onRecharge,
}: LowCreditBannerProps): ReactElement {
    const { t } = useTranslation('billing')

    return (
        <div className={styles.banner}>
            <div className={styles.text}>{t('outOfCredits')}</div>
            <div className={styles.actions}>
                <button type="button" className={styles.link} onClick={onRecharge}>
                    {t('rechargeCredits')}
                </button>
            </div>
        </div>
    )
}
